"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTotalOrderMargin = void 0;
const getLatestOrderLineVersion_1 = require("./getLatestOrderLineVersion");
const getOrderLineMargin_1 = require("./getOrderLineMargin");
const getTotalOrderMargin = (order) => {
    if (!order)
        return 0;
    if (!order.order_lines)
        return 0;
    return order.order_lines.reduce((acc, cur) => {
        if (!cur.versions)
            return acc;
        const latest_version = (0, getLatestOrderLineVersion_1.getLatestOrderLineVersion)(cur.versions);
        if (!latest_version)
            return acc;
        const config = latest_version.config;
        return acc + (0, getOrderLineMargin_1.getOrderLineMargin)(config, cur.type);
    }, 0);
};
exports.getTotalOrderMargin = getTotalOrderMargin;
